import React, { useEffect, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import Icon from '../../components/Icon';
import { useAdminAuth } from '../context/AdminAuthContext';

const LINKS = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: 'grid' },
  { to: '/admin/enquiries', label: 'Enquiries', icon: 'inbox' },
  { to: '/admin/projects', label: 'Projects', icon: 'building' },
  { to: '/admin/office', label: 'Office Info', icon: 'pin' },
  { to: '/admin/settings', label: 'Settings', icon: 'settings' },
];

export default function AdminLayout({ children }) {
  const { admin, logout } = useAdminAuth();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => { setOpen(false); }, [pathname]);
  const initial = (admin?.name || 'A').charAt(0).toUpperCase();

  return (
    <div className="adm">
      <div className="adm-mobile-bar">
        <strong style={{ fontFamily: 'var(--font-head)' }}>Blue Block Admin</strong>
        <button onClick={() => setOpen((o) => !o)} aria-label="Toggle menu"><Icon name={open ? 'close' : 'menu'} /></button>
      </div>
      <aside className={`adm-side${open ? ' open' : ''}`}>
        <div className="adm-brand">
          <span className="mark"><img src="/logo-160.png" alt="" /></span>
          <div><strong>Blue Block</strong><small>Admin Panel</small></div>
        </div>
        {LINKS.map((l) => (
          <NavLink key={l.to} to={l.to} className={({ isActive }) => `adm-link${isActive ? ' active' : ''}`}>
            <Icon name={l.icon} size={19} />{l.label}
          </NavLink>
        ))}
        <div className="adm-side-foot">
          <div className="adm-user">
            <span className="av">{initial}</span>
            <div><strong>{admin?.name || 'Admin'}</strong><small>{admin?.email}</small></div>
          </div>
          <Link to="/" className="adm-link" target="_blank"><Icon name="external" size={18} />View Website</Link>
          <button className="adm-link" onClick={logout}><Icon name="logout" size={18} />Log out</button>
        </div>
      </aside>
      <main className="adm-main">{children}</main>
    </div>
  );
}

/* Small shared bits for admin pages */
export function AdminHeader({ title, subtitle, children }) {
  return (
    <div className="adm-top">
      <div><h1>{title}</h1>{subtitle && <p>{subtitle}</p>}</div>
      {children && <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>{children}</div>}
    </div>
  );
}

export function useToast() {
  const [toast, setToast] = useState(null);
  useEffect(() => {
    if (!toast) return undefined;
    const t = setTimeout(() => setToast(null), 3000);
    return () => clearTimeout(t);
  }, [toast]);
  const node = toast ? <div className={`toast${toast.err ? ' err' : ''}`}><Icon name={toast.err ? 'close' : 'checkCircle'} size={18} />{toast.msg}</div> : null;
  return [node, (msg, err = false) => setToast({ msg, err })];
}

export const fmtDate = (d) => (d ? new Date(d).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—');
